<div class="page-wrapper"
     [elementHeight]="'app'">
    <!-- NOTE: page-wrapper class is required for modals to be created inside of it -->

    <!-- off canvas is on top, as it scrolls from the top -->
    @if(client.isS || client.isM){

    @defer (on immediate; hydrate on viewport) {
    <page-off-canvas [toggleClass]="'_visible'"
                     [toggleClassBy]="offCanvasState"
                     [offCanvasState]="offCanvasState" />
    }
    }

    <app-busy-state></app-busy-state>

    <router-app-busy-state></router-app-busy-state>

    <div [elementHeight]="headerElementId"
         [elementHeightOptions]="{topOffset: true, local: false}">
        <page-header [offCanvasState]="offCanvasState"
                     #pageHeader></page-header>
    </div>

    @if (hasHeader) {
    <main [class.page-content]="isAfterContentInit()"
          [elementHeight]="'page-content'"
          navigationHeightHold>
        <router-outlet #outlet="outlet"></router-outlet>
    </main>
    }

    <!-- page footer -->
    <!-- @defer (on immediate; hydrate on viewport) { -->
    <page-footer *ifNotCheckoutProcess
                 [elementHeight]="'page-footer-wrapper'" />
    <!-- } -->
</div>